import * as React from 'react';
import {View, StyleSheet} from 'react-native';
import AVText from 'src/components/elements/AVText';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import Styles from 'src/components/Styles';

type DialogueBodyProps = {
  description: string;
};

const DialogueBody = (props: DialogueBodyProps) => {
  return (
    <View
      style={[styles.descriptionStyle]}
      accessible
      accessibilityLabel="Modal Body"
      testID="qa_Checkout.ModalBody_txt"
      nativeID="qa_Checkout.ModalBody_txt"
    >
      <AVText
        style={[
          styles.descText,
          getSnackDescriber()?.snackDetailsBtnFontSTyle(),
        ]}
        numberOfLines={0}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
        accessible
        accessibilityLabel={props.description}
        aria-label={`${props.description} Text`}
      >
        {props.description}
      </AVText>
    </View>
  );
};

const styles = StyleSheet.create({
  descriptionStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: Styles.Spacing.m3,
    marginTop: Styles.Spacing.m3,
  },
  descText: {
    color: Styles.black,
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    textAlign: 'center',
  },
});
export default DialogueBody;
